import { useContext } from "react";
import {
  VersionPollingContext,
  VersionPollingContextValue,
} from "../context/version-polling-provider";

/**
 * Returns the version polling state so UI components can react to
 * new deployments detected by the {@link VersionPollingProvider}.
 */
export const useVersionPolling = (): VersionPollingContextValue => {
  return useContext(VersionPollingContext);
};
